<template>
  <v-container fluid class="ma-4 px-8">
    <div>
      <v-row>
        <v-col cols="12" md="2" v-if="tab == 0 || tab == 1">
          <v-select
            v-model="form.year_batch"
            :items="batches"
            clearable
            outlined
            dense
            hide-details="auto"
            label="Batch"
          ></v-select>
        </v-col>
        <!--<v-col cols="3">
          <v-autocomplete
            v-model="form.filter_by"
            :items="filterBy"
            item-text="text"
            item-value="value"
            outlined
            dense
            hide-details="auto"
            label="Filter By"
            @change="getCFOPayments()"
          ></v-autocomplete
        ></v-col> -->
        <v-col cols="12" md="2" v-if="tab == 1">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="displayDate"
                readonly
                outlined
                label="Date Range"
                dense
                v-bind="attrs"
                v-on="on"
                hide-details="auto"
              ></v-text-field>
            </template>
            <v-sheet
              class="pa-4"
              elevation="4"
              style="background-color: white; border-radius: 8px"
            >
              <v-row no-gutters>
                <v-col>
                  <v-date-picker
                    v-model="selectedDates"
                    range
                    @input="onDateChange"
                  ></v-date-picker>
                </v-col>
                <v-col class="pl-4 pt-4" style="max-width: 150px">
                  <div
                    v-for="option in dateOptions"
                    :key="option.label"
                    class="mb-2 pt-2"
                  >
                    <v-btn small color="accent" @click="setQuickDate(option)">
                      {{ option.label }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2" v-if="tab == 0">
          <v-btn class="accent white--text" @click="searchFilter">
            Search
          </v-btn>
        </v-col>
        <v-col cols="12" md="2" v-if="tab == 1">
          <v-text-field
            v-model="form.transaction_id"
            hide-details="auto"
            label="Transaction ID"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <div class="d-flex ma-2" v-if="tab != 1 && tab != 2">
          <v-btn
            class="success white--text ml-3"
            @click="showConfirmation()"
            :disabled="!hasSelectedItems"
          >
            Verify
          </v-btn>
          <v-btn
            v-if="loanTab == 1"
            :disabled="!cfoItems.length"
            class="accent white--text ml-2"
            @click="download()"
          >
            <v-icon>mdi-download</v-icon> Download
          </v-btn>
        </div>
        <div v-if="tab == 1">
          <v-col
            ><v-btn class="accent white--text" @click="searchFilter">
              Search
            </v-btn>
            <v-btn
              @click="settlementDownload()"
              :disabled="!settlements.length"
              class="accent white--text ml-2"
            >
              <v-icon>mdi-download</v-icon> Download
            </v-btn>
          </v-col>
        </div>
      </v-row>
      <!-- <v-btn
            class="error white--text ml-3"
            @click="dialog = true"
          >
            Reject
          </v-btn> -->
    </div>
    <v-row class="pb-0">
      <v-col>
        <v-tabs
          v-model="tab"
          class="d-flex justify-center"
          grow
          @change="selectedApplicants = []"
        >
          <v-tab>Loan Payments</v-tab>
          <v-tab>Settled Payments</v-tab>
          <v-tab>Bulk Payments</v-tab>
          <v-tab>Excess Payments</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row class="pt-0 align-center" v-if="tab == 0">
      <v-col class="pt-0 d-flex justify-center">
        <v-tabs v-model="loanTab" @change="selectedApplicants = []">
          <v-tab>To Verify</v-tab>
          <v-tab>Verified</v-tab>
        </v-tabs>
      </v-col>

      <v-col
        v-if="loanTab == 1 && lastRealizedDate"
        cols="auto"
        class="d-flex justify-end"
      >
        <div class="text-right">
          Last Realized Date: {{ formatDate(lastRealizedDate) }}
        </div>
      </v-col>
    </v-row>

    <v-tabs-items v-model="tab" class="mt-2">
      <v-tab-item> </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                :headers="finalSettlementHeaders"
                :items="settlements"
                fixed-header
                :loading="loading"
                class="secondary row-height-50"
              >
                <template #[`item.settled_transactions`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    color="accent"
                    @click="navigate(item)"
                  >
                    mdi-dots-horizontal
                  </v-icon>
                </template>
                <template #[`item.date`]="{ value }">
                  {{ formatSettlementDate(value, false) }}
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                v-model="selectedBulkPayments"
                :headers="CFOBulkPaymentHeaders"
                :items="bulkPayments"
                fixed-header
                :loading="loading"
                class="secondary row-height-50"
              >
                <template #[`item.view`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    color="accent"
                    @click="navigateToBulkDeskStudents(item)"
                  >
                    mdi-dots-horizontal
                  </v-icon>
                </template>

                <template #[`item.partner_id`]="{ value }">
                  {{ getPartnerName(value) }}
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                v-model="selectedExcessPayments"
                :headers="excessPaymentHeaders"
                :items="excessPayments"
                fixed-header
                :loading="loading"
                :show-select="true"
                single-select
                @item-selected="onExcessPaymentSelected"
                class="secondary row-height-50"
              >
                
              <template #[`item.batch`]="{ item }">
                  {{ item.year ? `${item.year} - ${item.batch}` : item.batch }}
                </template>
                <template #[`item.transaction_date`]="{ value }">
                  {{ formatTransactionDate(value) }}
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <v-tabs-items v-model="loanTab" v-if="tab == 0">
      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                v-model="selectedLoanPayments"
                :headers="paidCfoHeaders"
                :items="cfoItems"
                fixed-header
                :loading="loading"
                :show-select="true"
                single-select
                @item-selected="onLoanPaymentSelected"
              >
                <template v-slot:[`item.transaction_id`]="{ item }">
                  {{ item.loan_utr ? item.loan_utr : item.transaction_id }}
                </template>
                <template v-slot:[`item.partner_id`]="{ item }">
                  {{ getPartnerName(item.partner_id) }}
                </template>
                <template v-slot:[`item.program_id`]="{ item }">
                  {{ getProgramName(item.program_id) }}
                </template>
                <template v-slot:[`item.payment_date`]="{ item }">
                  {{ formatDate(item.payment_date) }}
                </template>
                <template v-slot:no-data>
                  <div class="text-center">No data available</div>
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                v-model="selectedLoanPayments"
                :headers="computedPaidCfoHeaders"
                :items="cfoItems"
                fixed-header
                :loading="loading"
              >
                <template v-slot:[`item.transaction_id`]="{ item }">
                  {{ item.loan_utr ? item.loan_utr : item.transaction_id }}
                </template>
                <template v-slot:[`item.partner_id`]="{ item }">
                  {{ getPartnerName(item.partner_id) }}
                </template>
                <template v-slot:[`item.program_id`]="{ item }">
                  {{ getProgramName(item.program_id) }}
                </template>
                <template v-slot:[`item.payment_date`]="{ item }">
                  {{ formatDate(item.payment_date) }}
                </template>
                <template v-slot:[`item.realization_date`]="{ item }">
                  {{ formatDate(item.realization_date) }}
                </template>
                <template v-slot:no-data>
                  <div class="text-center">No data available</div>
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="excessConfirmationDialog" width="500" persistent>
      <confirmationDialog
        v-if="excessConfirmationDialog"
        :confirmationText="`Are you sure you want to confirm receipt of the payment${
          selectedItems.length > 1 ? 's' : ''
        }?`"
        :loading="loading"
        @closeDialog="excessConfirmationDialog = false"
        @saveDialog="updateExcessPayments()"
      />
    </v-dialog>

    <v-dialog v-model="confirmationDialog" width="500" persistent>
      <v-card>
        <v-card-title class="font-weight-medium secondary--text primary">
          Confirm Payment
          <v-spacer></v-spacer>
          <v-btn icon large @click="confirmationDialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="subtitle-2">
            Do you want to confirm that the payment has been received?
          </div>
          <div>
            <v-row class="mt-3" no-gutters>
              <v-col cols="12"
                ><b>Transaction Date:</b> {{ formatPaymentDate }}
              </v-col>
              <v-col cols="12"
                ><b>Transaction ID:</b> {{ selectedItem?.loan_utr }}
              </v-col>
              <v-col cols="12"
                ><b>Amount:</b> {{ selectedItem?.payment_amount }}
              </v-col>
              <v-col cols="6" class="pt-6">
                <v-menu
                  v-model="showDatePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="realizationDateDisplay"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Realization Date*"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        (v) =>
                          !!realization_date || 'Realization date is required',
                      ]"
                    />
                  </template>
                  <v-date-picker
                    v-model="realization_date"
                    @input="showDatePicker = false"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions class="mt-n3">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!realization_date"
            :loading="loading"
            @click="updatePaymentStatus()"
            >Verify</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <v-card-title class="headline"> Reject Reason </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                class="mt-2"
                rows="2"
                dense
                label="Remarks"
                outlined
                v-model="remarks"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog = false">Cancel</v-btn>
          <v-btn color="success" @click="updatePaymentRemark()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  paidCfoHeaders,
  settlementHeaders,
  CFOBulkPaymentHeaders,
  excessPaymentHeaders,
} from "@/constants/headers";
import confirmationDialog from "@/components/confirmationDialog.vue";

export default {
  components: { confirmationDialog },
  data() {
    return {
      paidCfoHeaders,
      settlementHeaders,
      CFOBulkPaymentHeaders,
      excessPaymentHeaders,
      programs: [],
      partners: [],
      selectedLoanPayments: [],
      selectedBulkPayments: [],
      selectedExcessPayments: [],
      selectedItem: null,
      realizationDate: null,
      selectedItems: [],
      confirmationDialog: false,
      excessConfirmationDialog: false,
      dialog: false,
      remarks: null,
      cfoItems: [],
      form: {
        filter_by: "application",
        from_date: "",
        to_date: "",
      },
      filterBy: [
        { text: "Pre Application", value: "pre_application" },
        { text: "Application", value: "application" },
      ],
      tab: 0,
      loanTab: 0,
      settlements: [],
      selectedDates: [],
      menu: false,
      displayDate: "",
      dateOptions: [
        { label: "Today", days: 0 },
        { label: "Yesterday", type: "yesterday" },
        { label: "This Week", type: "week" },
        { label: "Last 7 Days", days: 6 },
        { label: "This Month", type: "month" },
        { label: "Last 30 Days", days: 29 },
        { label: "Reset", type: "reset" },
      ],
      loading: false,
      batches: [],
      finalSettlementHeaders: [],
      bulkPayments: [],
      excessPayments: [],
      realization_date: null,
      showDatePicker: false,
      lastRealizedDate: null,
    };
  },
  watch: {
    loanTab(val) {
      this.selectedLoanPayments = [];
      this.selectedItem = null;
      this.getCFOPayments({ is_verified: val === 1 });
    },
    tab: {
      handler(newValue, oldValue) {
        if (newValue === 0) {
          this.loanTab = 0;
          this.getCFOPayments({ is_verified: false });
        }
        if (newValue === 1) this.getSettlements();
        if (newValue === 2) this.getBulkPayments();
        if (newValue === 3) this.getExcessPayments();
      },
      immediate: true,
    },
    showDatePicker(val) {
      if (val && this.selectedItem?.payment_date) {
        this.realization_date = this.selectedItem.payment_date; // YYYY-MM-DD
      }
    },
  },
  computed: {
    formatDate() {
      return (date) => {
        if (!date) return "";
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      };
    },
    maxDate() {
      return this.selectedItem?.payment_date || undefined;
    },
    hasSelectedItems() {
      if (this.tab === 0) {
        return this.selectedLoanPayments.length > 0;
      } else if (this.tab === 2) {
        return this.selectedBulkPayments.length > 0;
      } else if (this.tab === 3) {
        return this.selectedExcessPayments.length > 0;
      }
      return false;
    },
    realizationDateDisplay() {
      if (!this.realization_date) return "";

      const [year, month, day] = this.realization_date.split("-");
      return `${day}-${month}-${year}`;
    },

    formatPaymentDate() {
      if (!this.selectedItem?.payment_date) return "";

      const [year, month, day] = this.selectedItem?.payment_date.split("-");
      return `${day}-${month}-${year}`;
    },
    computedPaidCfoHeaders() {
      let headers = [...paidCfoHeaders];

      if (this.loanTab === 1) {
        headers.push({
          text: "Realization Date",
          value: "realization_date",
          class: "black--text font-weight-bold secondary",
        });
      }

      return headers;
    },
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Transaction Verification" }]);

    this.finalSettlementHeaders = this.injectCustomSort(
      this.settlementHeaders,
      ["date"],
    );
    this.init();
  },
  methods: {
    async getCFOPayments(extraFilters = {}) {
      const queryString = this.objectToQueryParams({
        ...this.form,
        ...extraFilters,
      });
      this.loading = true;
      try {
        let res = await this.$axios.get(
          `/loan_approval_payments?${queryString}`,
        );

        this.cfoItems = res.data.data;
        this.cfoItems.sort(
          (a, b) => new Date(b.realization_date) - new Date(a.realization_date),
        );
        this.lastRealizedDate = this.cfoItems[0]?.realization_date || null;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error.response?.data?.message || "No Data Found",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    async getSettlements() {
      // Settlements API does not use filter_by — strip it from the params.
      const params = { ...this.form };
      delete params.filter_by;
      const queryString = this.objectToQueryParams(params);
      this.loading = true;
      try {
        const response = await this.$axios.get(
          `list_unverified_settlements?${queryString}`,
        );
        this.settlements = response.data.data.sort((a, b) => {
          const aTime = this.parseDate(a.date);
          const bTime = this.parseDate(b.date);
          return bTime - aTime;
        });
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error.response.data.message || "No Data Found",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    formatTransactionDate(date) {
      const newDate = new Date(date);
      const ISTOffset = 5.5 * 60 * 60 * 1000;
      const ISTDate = new Date(
        newDate.getTime() + ISTOffset + newDate.getTimezoneOffset() * 60 * 1000,
      );
      const ISTDateParts = ISTDate.toISOString().split("T")[0].split("-");
      const ISTTimeParts = ISTDate.toTimeString().split(" ")[0].split(":");
      return `${ISTDateParts[2]}-${ISTDateParts[1]}-${ISTDateParts[0]} ${ISTTimeParts[0]}:${ISTTimeParts[1]}`;
    },
    async getExcessPayments() {
      const excessPaymentFilter = {
        finance_check: "N",
      };
      const queryString = this.objectToQueryParams({
        ...excessPaymentFilter,
      });
      this.loading = true;
      try {
        const response = await this.$axios.get(
          `excess_payments?${queryString}`,
        );
        // Response is grouped by student ({ ...student, entries: [...] }).
        // Flatten into one clean row per payment entry for the data table,
        // carrying student-level fields down as a fallback.
        this.excessPayments = (response.data.data || [])
          .flatMap((student) =>
            (student.entries || []).map((entry) => ({
              ...entry,
              application_id: entry.application_id || student.application_id,
              name: entry.name || student.name,
              email: entry.email || student.email,
              mobile_no: entry.mobile_no || student.mobile_no,
              usn_id: entry.usn_id || student.usn_id,
            })),
          )
          .sort((a, b) => b.id - a.id);
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error.response?.data?.message || "No Data Found",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    objectToQueryParams(obj) {
      if (obj.year_batch) {
        const [year, batch] = obj.year_batch.split("-");
        obj.year = parseInt(year, 10);
        obj.batch = parseInt(batch, 10);
        delete obj.year_batch;
      }
      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== "",
        ) // Remove undefined/null values
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]),
        )
        .join("&");
    },
    async updatePaymentRemark() {
      this.$axios
        .put(`/update_payment_by_cfo/`, {
          remarks: this.remarks,
          ids: this.selectedItems.map((item) => item.id),
        })
        .then(() => {
          this.dialog = false;
          this.init();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async updatePaymentStatus() {
      this.loading = true;
      let selectedIds = [];

      if (this.tab === 0) {
        selectedIds = this.selectedLoanPayments.map((item) => item.id);
      } else if (this.tab === 2) {
        selectedIds = this.selectedBulkPayments.map((item) => item.id);
      } else if (this.tab === 3) {
        selectedIds = this.selectedExcessPayments.map((item) => item.id);
      }

      if (selectedIds.length === 0) {
        this.$store.commit("showSnackbar", {
          message: "Please select an item first",
          color: "error",
        });
        return;
      }

      this.$axios
        .put(`/update_payment_by_cfo/`, {
          ids: selectedIds,
          filter_by: this.form.filter_by,
          realization_date: this.realization_date,
        })
        .then(() => {
          this.confirmationDialog = false;
          if (this.tab === 0) {
            this.selectedLoanPayments = [];
          } else if (this.tab === 2) {
            this.selectedBulkPayments = [];
          } else if (this.tab === 3) {
            this.selectedExcessPayments = [];
          }
          this.loading = false;
          this.init();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async init() {
      await Promise.all([
        this.getPrograms(),
        this.getPartners(),
        this.generateBatchList(),
        this.getCFOPayments({ is_verified: false }),
      ]);
    },
    async getPrograms() {
      try {
        const response = await this.$axios.get("/programs");
        this.programs = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },

    getProgramName(id) {
      const program = this.programs.find((p) => p.id === id);
      return program
        ? program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "")
        : "";
    },
    async getPartners() {
      try {
        const response = await this.$axios.get("/partners");
        this.partners = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    getPartnerName(id) {
      const partner = this.partners.find((partner) => partner.id === id);
      return partner ? partner.name : "";
    },

    async settlementDownload() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.$axios
        .get(`/download_collection_report?${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Settlements.csv");
          document.body.appendChild(link);
          link.click();
        });
    },

    async getBulkPayments() {
      this.loading = true;
      try {
        const response = await this.$axios.get(
          `/business_partner_bulk_payments?finance_check=N`,
        );
        this.bulkPayments = response.data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async download() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      const is_verified = this.loanTab === 0 ? false : true;

      let url = "";
      if (this.loanTab === 0) url = `download_cfo_approval?${queryString}`;
      if (this.loanTab === 1)
        url =
          `download_cfo_approved_loan_payments?${queryString}&is_verified=` +
          is_verified;
      if (this.tab === 2) url = "download_cfo_bulk_payments";
      if (this.tab === 3) url = "download_excess_payment";

      const [_, name1, name2] = url.split("_");
      let params;
      if (this.tab === 0) {
        params = {
          filter_by: this.form.filter_by,
        };
      }
      this.$axios
        .get(url, {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${name1.charAt(0).toUpperCase() + name1.slice(1)} ${name2}.csv`,
          );
          document.body.appendChild(link);
          link.click();
        });
    },
    formatSettlementDate(dateString, needHour) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hour = date.getHours().toString().padStart(2, "0");
      const minute = date.getMinutes().toString().padStart(2, "0");
      return needHour
        ? `${month}-${day}-${year} ${hour}:${minute}`
        : `${day}-${month}-${year}`;
    },
    navigate(item) {
      this.$router.push({
        path: `/settlements/${item.pv_number}/verify-transactions`,
      });
    },
    onDateChange() {
      if (this.selectedDates.length === 2) {
        const [fromDate, toDate] = this.selectedDates;
        this.form.from_date = this.formatDateBackend(fromDate);
        this.form.to_date = this.formatDateBackend(toDate);
        this.displayDate = this.formatDisplayDate(fromDate, toDate);
      }
    },
    setQuickDate(option) {
      const today = new Date();
      let fromDate = new Date(today);
      let toDate = new Date(today);

      if (option.type === "reset") {
        this.form.from_date = null;
        this.form.to_date = null;
        this.displayDate = "";
        this.selectedDates = [];
        return;
      }

      if (option.type === "week") {
        fromDate.setDate(today.getDate() - today.getDay());
      } else if (option.type === "month") {
        fromDate.setDate(1);
      } else if (option.type === "yesterday") {
        fromDate.setDate(today.getDate() - 1);
        toDate.setDate(today.getDate() - 1);
      } else if (option.days != null) {
        fromDate.setDate(today.getDate() - option.days);
      }

      this.selectedDates = [fromDate, toDate];
      this.onDateChange();
    },
    formatDateBackend(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0",
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    formatDisplayDate(fromDate, toDate) {
      const format = (d) =>
        `${String(d.getDate()).padStart(2, "0")}-${String(
          d.getMonth() + 1,
        ).padStart(2, "0")}-${d.getFullYear()}`;
      return `${format(new Date(fromDate))} ~ ${format(new Date(toDate))}`;
    },
    searchFilter() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      if (this.tab === 0) {
        const isVerified = this.loanTab === 1;
        this.getCFOPayments({ is_verified: isVerified, ...this.form });
      }
      if (this.tab === 1) this.getSettlements();
      if (this.tab === 2) this.getBulkPayments(queryString);
    },
    async generateBatchList() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    customDateSort(a, b) {
      const dateA = new Date(a).getTime();
      const dateB = new Date(b).getTime();

      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
      return 0;
    },
    injectCustomSort(headers, dateFields) {
      return headers.map((header) => {
        if (dateFields.includes(header.value)) {
          return { ...header, sort: this.customDateSort };
        }
        return header;
      });
    },
    onItemSelected({ item, value }) {
      if (value) {
        this.selectedItem = { ...item };
        this.confirmationDialog = true;
        this.$nextTick(() => {
          this.realization_date = this.selectedItem.payment_date;
        });
      } else {
        this.selectedItem = null;
      }
    },
    onLoanPaymentSelected({ item, value }) {
      if (value) {
        this.selectedLoanPayments = [item];
        this.selectedItem = { ...item };
        this.realization_date = this.selectedItem.payment_date;
      } else {
        this.selectedLoanPayments = [];
      }
    },

    onExcessPaymentSelected({ item, value }) {
      if (value) {
        this.selectedExcessPayments = [item];
        this.selectedItem = { ...item };
        this.realization_date = this.selectedItem.payment_date;
      } else {
        this.selectedExcessPayments = [];
      }
    },
    navigateToBulkDeskStudents(item) {
      this.$router.push({
        path: `cfo_bulk_payment_students`,
        query: {
          id: `${item.id}`,
          payment_type: `${item.payment_type}`,
        },
      });
    },
    showConfirmation() {
      if (this.tab == 3) {
        this.excessConfirmationDialog = true;
        return;
      }
      this.confirmationDialog = true;
    },
    async updateExcessPayments() {
      try {
        this.loading = true;
        await this.$axios.put("/update_cfo_excess_payments", {
          id: this.selectedItem.id,
        });
        this.excessConfirmationDialog = false;
        await this.getExcessPayments();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    parseDate(dateStr) {
      console.log("Parsing date:", dateStr);

      // Handle "DD/MM/YYYY" format
      if (dateStr.includes("/")) {
        const [day, month, year] = dateStr.split("/");
        const date = new Date(year, parseInt(month) - 1, day);
        console.log("  -> Parsed as DD/MM/YYYY:", date.toISOString());
        return date.getTime();
      }

      // Handle "MMM DD, YYYY" format
      const months = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };

      const parts = dateStr.split(" ");
      console.log("  Parts:", parts);

      const month = parts[0];
      const dayWithComma = parts[1];
      const year = parts[2];

      const monthNum = months[month];
      const dayNum = parseInt(dayWithComma.replace(",", ""));

      console.log("  Month:", month, "->", monthNum);
      console.log("  Day:", dayNum);
      console.log("  Year:", year);

      const date = new Date(year, monthNum, dayNum);
      console.log("  -> Parsed as MMM DD, YYYY:", date.toISOString());

      return date.getTime();
    },
  },
};
</script>

<style></style>
